import { render } from "./ActivityLoader.vue?vue&type=template&id=2cf5afaa&scoped=true&ts=true"
import script from "./ActivityLoader.vue?vue&type=script&lang=ts"
export * from "./ActivityLoader.vue?vue&type=script&lang=ts"

import "./ActivityLoader.vue?vue&type=style&index=0&id=2cf5afaa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf5afaa"]])

export default __exports__